import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-circle-o.icon",
  "use": "check-circle-o.icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"check-circle-o.icon\">\n    <path d=\"M8 0C3.587 0 0 3.587 0 8s3.587 8 8 8 8-3.587 8-8-3.587-8-8-8zm0 15.023A7.03 7.03 0 01.977 8 7.03 7.03 0 018 .977 7.03 7.03 0 0115.023 8 7.03 7.03 0 018 15.023z\" fill=\"#77AB2E\" />\n    <circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"currentColor\" />\n    <path d=\"M6.99 9.482L4.582 7.074l-.86.859L6.99 11.2l5.592-5.592-.876-.859L6.99 9.482z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol